const SESSION_WINDOW_PREFIX = "physician-session";
const sessionWindows = new Map();

export const getPhysicianSessionPath = (appointmentId) =>
  `/physician/appointments/${appointmentId}/session`;

export const isProviderVisitAppointment = (appointment = {}) => {
  const appointmentType = String(appointment.appointmentType || "")
    .trim()
    .toLowerCase()
    .replace(/[\s-]+/g, "_");

  return Boolean(
    appointment.isProviderVisit ||
      appointment.providerVisitId ||
      appointmentType === "provider_visit",
  );
};

export const getPhysicianZoomUrl = (appointment = {}) =>
  appointment.zoomStartUrl ||
  appointment.zoomJoinUrl ||
  appointment.zoomLink ||
  "";

export const openPhysicianSession = (appointmentId) => {
  if (!appointmentId) return null;

  const bootstrapPath = `/?physicianSession=${encodeURIComponent(appointmentId)}`;
  const windowName = `${SESSION_WINDOW_PREFIX}-${appointmentId}`;
  const existingWindow = sessionWindows.get(appointmentId);

  if (existingWindow && !existingWindow.closed) {
    existingWindow.focus();
    return existingWindow;
  }

  const sessionWindow = window.open(
    bootstrapPath,
    windowName,
    "popup=yes,width=1440,height=900,resizable=yes,scrollbars=yes",
  );

  if (sessionWindow) {
    sessionWindows.set(appointmentId, sessionWindow);
    sessionWindow.focus();
    return sessionWindow;
  }

  window.location.assign(bootstrapPath);
  return null;
};

export const openPhysicianMeeting = (appointment = {}) => {
  const appointmentId = appointment._id || appointment.id;
  if (!appointmentId) return { opened: false, reason: "appointment" };

  if (isProviderVisitAppointment(appointment)) {
    openPhysicianSession(appointmentId);
    return { opened: true, type: "video-sdk" };
  }

  const zoomUrl = getPhysicianZoomUrl(appointment);
  if (!zoomUrl) return { opened: false, reason: "zoom-link" };

  window.open(zoomUrl, "_blank", "noopener,noreferrer");
  return { opened: true, type: "zoom" };
};